import { createFileRoute } from "@tanstack/react-router";
import {
  ScheduleLandingPage,
  scheduleSeoHead,
  vslMediaConfig,
  type ScheduleOffer,
} from "@/components/schedule-landing-page";
import { REVENUE_OPTIONS, type FormStep } from "@/components/schedule-lead-form";
import { CALENDLY_DEMO_URL } from "@/lib/cta";

const LP_PATH = "/lp/schedule";
// Kept short: `seo()` appends " — Axy.digital", and the pair has to survive
// Google's ~60-char SERP truncation.
const LP_TITLE = "Increase AI Mentions and Citations in 90 Days";
const LP_DESCRIPTION =
  "Book a 20-minute call. We run a full AI Visibility Audit on your brand and hand you a 90-day GEO blueprint — yours to keep, whether you work with us or not.";

const CTA_NOTES = [
  "Join the 1,200+ brands already using axy.digital.",
  "Takes 60 seconds • Get a custom report showing what LLMs are saying about you vs. competitors.",
];

const STEPS: FormStep[] = [
  {
    type: "choice",
    key: "industry",
    eyebrow: "Qualify",
    title: "What industry are you in?",
    options: [
      "B2B software",
      "Professional service (accounting, law firm, consulting, etc.)",
      "Ecommerce",
      "Local business",
      "Other",
    ],
  },
  {
    type: "choice",
    key: "revenueRange",
    eyebrow: "Qualify",
    title: "Annual revenue range?",
    options: REVENUE_OPTIONS,
  },
  {
    type: "choice",
    key: "marketingTeamSize",
    eyebrow: "Qualify",
    title: "Size of your marketing team?",
    options: ["0 - 1", "2 - 5", "5 - 10", "> 10"],
  },
  {
    type: "choice",
    key: "worksWithAgency",
    eyebrow: "Last step",
    title: "Do you currently work with a marketing agency?",
    options: [
      "Yes",
      "Never",
      "Not right now, but in the past",
      "Not right now, but looking to hire one",
    ],
  },
];

const OFFER: ScheduleOffer = {
  paragraphs: [
    "We run a complete AI Visibility Audit on your brand and build your GEO roadmap on a 20-minute call.",
  ],
  listTitle: "What you'll get on the call",
  items: [
    {
      title: "AI Visibility Scorecard",
      description: "Exact data on how ChatGPT & Gemini perceive your brand.",
    },
    {
      title: "Competitor Citation Gaps",
      description: "Where competitors are stealing AI search traffic.",
    },
    {
      title: "90-Day Execution Blueprint",
      description: "Yours to keep, whether you work with us or not.",
    },
  ],
};

export const Route = createFileRoute("/lp/schedule")({
  head: () => scheduleSeoHead({ path: LP_PATH, title: LP_TITLE, description: LP_DESCRIPTION }),
  component: LandingPage,
});

function LandingPage() {
  return (
    <ScheduleLandingPage
      title="Use Axy.digital to increase AI mentions and citations in 90 days, or get your money back."
      ctaNotes={CTA_NOTES}
      offer={OFFER}
      trustLabel="TRUSTED BY 1,200+ BRANDS AND LEAN MARKETING TEAMS"
      formName="schedule"
      steps={STEPS}
      video={vslMediaConfig("vsl-schedule-non-agency")}
      calendlyUrl={CALENDLY_DEMO_URL}
    />
  );
}
